import type { Requests } from "../common/request.common";
import type { FinanceTaxResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const financeTax = {
    record(data: typeof Requests.FinanceTax.Record.Input) {
        return post<typeof data, FinanceTaxResponseTypes.Record>(`/finance-tax/record`, data);
    },
    invoiceRecord(id: string) {
        return (data: typeof Requests.FinanceTax.InvoiceRecord.Input) => {
            return post<typeof data, FinanceTaxResponseTypes.InvoiceRecord>(
                `/finance-tax/invoice-record/${id}`,
                data,
            );
        };
    },
    obtain(id: string) {
        return get<FinanceTaxResponseTypes.Obtain>(`/finance-tax/obtain/${id}`);
    },
    createSettlement(id: string, data: typeof Requests.FinanceTax.CreateSettlement.Input) {
        return post<typeof data>(`/finance-tax/create-settlement/${id}`, data);
    },
    generateExport(data: typeof Requests.FinanceTax.GenerateExport.Input) {
        return post<typeof data>(`/finance-tax/generate-export`, data);
    },
    dev: {
        delete(id: string) {
            return postEmpty(`/dev/finance-tax/delete/${id}`);
        },
    },
};
